<c-row class="g-4">
  <c-col xl="2" lg="4" sm="6">
    <c-widget-stat-e
      [title]="'title'"
      [value]="'1,123'"
    >
      <c-chart [data]="data[0]" [options]="barOptions" class="mx-auto" height="40" width="80" />
    </c-widget-stat-e>
  </c-col>
  <c-col xl="2" lg="4" sm="6">
    <c-widget-stat-e
      [title]="'title'"
      [value]="'1,123'"
    >
      <c-chart [data]="data[1]" [options]="barOptions" class="mx-auto" height="40" width="80" />
    </c-widget-stat-e>
  </c-col>
  <c-col xl="2" lg="4" sm="6">
    <c-widget-stat-e
      [title]="'title'"
      [value]="'1,123'"
    >
      <c-chart [data]="data[2]" [options]="barOptions" class="mx-auto" height="40" width="80" />
    </c-widget-stat-e>
  </c-col>
  <c-col xl="2" lg="4" sm="6">
    <c-widget-stat-e
      [title]="'title'"
      [value]="'1,123'"
    >
      <c-chart [data]="data[3]" [options]="lineOptions" class="mx-auto" height="40" type="line" width="80" />
    </c-widget-stat-e>
  </c-col>
  <c-col xl="2" lg="4" sm="6">
    <c-widget-stat-e
      [title]="'title'"
      [value]="'1,123'"
    >
      <c-chart [data]="data[4]" [options]="lineOptions" class="mx-auto" height="40" type="line" width="80" />
    </c-widget-stat-e>
  </c-col>
  <c-col xl="2" lg="4" sm="6">
    <c-widget-stat-e
      [title]="'title'"
      [value]="'1,123'"
    >
      <c-chart [data]="data[5]" [options]="lineOptions" class="mx-auto" height="40" type="line" width="80" />
    </c-widget-stat-e>
  </c-col>
</c-row>
